// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_2gHrbdSHmK","queueButton":"mO-tqQLH1V","icon":"_2Dl8Gk1uPU"};